module.exports = "/_next/static/images/app-intro-device-diputi@2x-min-0090d3b97e055669648deba2bf5cf8e5.png";